module.exports = __webpack_public_path__ + "img/img1-opt.4e8cb10a.jpg";